<section class="not-found__section">
    <h1 class="not-found__title">404</h1>
    <p class="not-found__subtitle">Opsss! Página não encontrada!</p>
    <a routerLink="/" class="not-found__home-link">Home</a>
    <a (click)="auth.signOut()" class="not-found__exit-link">Sair</a>
</section>
